module.exports = __webpack_public_path__ + "img/car2.615ef39b.png";